import React from 'react';
import BeaconDropdownMetricColumnChart from 'src/components/BeaconV2Components/BeaconMetricColumnChart/BeaconDropdownMetricColumnChart';
import useKeywordSearchRequestBuilder from 'src/components/BeaconV2Components/ExperimentalLayout/Segments/KeywordsSearch/useKeywordSearchRequestBuilder';
import TopEntityChartV2Loading from 'src/components/BeaconV2Components/TopEntityChartV2/TopEntityChartV2Loading';
import AdvancedSearchRequestBuilder from 'src/components/BeaconV2Components/utils/AdvancedSearchRequestBuilder';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';

export const KeywordAdClicksColumnChart = ({
  builderFunction
}: {
  builderFunction?: (
    additionalBuilder?: (builder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder
  ) => (requestBuilder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder;
}) => {
  const entityType = useMainEntityType();
  const keywordSearchRequestBuilder = useKeywordSearchRequestBuilder('advertising');
  const builderToUse = builderFunction || keywordSearchRequestBuilder;
  return (
    <BeaconDropdownMetricColumnChart
      useAdvancedSearchDataArgs={{
        requestBuilder: builderToUse((builder) => {
          // Ad clicks uses different terms for keywords
          return builder
            .replaceConditionTermFilterFieldName('searchTermFuzzy', 'searchKeywordFuzzy')
            .replaceConditionTermFilterFieldName('excludedSearchTerm', 'excludedSearchKeyword')
            .replaceConditionTermFilterFieldName('excludedSearchTermFuzzy', 'excludedSearchKeywordFuzzy')
            .replaceConditionTermFilterFieldName('searchTerm', 'searchKeyword');
        })
      }}
      beaconChartWithLegendPropsBuilder={(props) => ({
        ...props,
        loadingComponent: <TopEntityChartV2Loading />
      })}
      indexName="advertising"
      fieldName="clicks"
      dropdownOptions={[
        {
          id: 'brandId',
          label: 'Brand'
        },
        {
          id: 'categoryId',
          label: 'Category'
        },
        {
          id: 'subCategoryId',
          label: 'Subcategory'
        }
      ].filter((option) => !option.id.toLowerCase().startsWith(entityType))}
      titlePrefix="Ad Clicks by"
    />
  );
};
